import React, {useMemo} from "react";
import {useHtmlClassService} from "../../../_metronic/layout/_core/MetronicLayout";

export function Brand() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo()
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Brand */}
      <div
          className={`brand flex-column-auto ${layoutProps.brandClasses}`}
          id="kt_brand"
      >
        {/* begin::Logo */}
        <div className="brand-logo">
        </div>
        {/* end::Logo */}

        {/* begin::Toggle */}
        <div className="brand-toggle px-0" id="kt_aside_toggl">
          <div className="toggle-menu-icon"></div>
        </div>
        {/* end::Toolbar */}
      </div>
      {/* end::Brand */}
      </>
  );
}
